export const handleBlur = (): void => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur()
  }
}
